import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import BasePage from "./base-page";
import SideBar from "./parts/sidebar";
import { useAuth } from "../providers/auth-provider";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

export default function DefaultLayout({ sidebarId, children, title = "" }) {
  const [showTooltip, setShowTooltip] = React.useState(false);
  const { user } = useAuth();
  const location = useLocation();
  const TOOLTIP_TEXT =
    "Advertising metrics (Revenue, CPM, Costs, and Impressions) are provisional estimates for performance tracking only.";

  React.useEffect(() => {
    document.title = title;
  }, [title]);

  const toggleTooltip = React.useCallback(() => {
    setShowTooltip((prev) => !prev);
  }, []);

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return (
    <BasePage>
      <div className={`app-route ${sidebarId}`}>
        <SideBar currentPage={sidebarId} />
        <div
          className="app-wrapper"
          onClick={() => {
            if (showTooltip) {
              setShowTooltip(false);
            }
          }}
        >
          <div
            className="app-wrapper__lower-icon"
            onClick={() => {
              toggleTooltip();
            }}
          >
            <HelpOutlineRoundedIcon />
          </div>
          <div
            className={`app-wrapper__tooltip ${
              showTooltip ? "" : "app-wrapper__tooltip--hidden"
            }`}
          >
            {TOOLTIP_TEXT}
          </div>
          {children}
        </div>
      </div>
    </BasePage>
  );
}
